import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { InitialOptions } from '../../utils/constants';

const ApexChart = ({ data, onDeltaChange }) => {
  const [series, setSeries] = useState([]);
  const [dayChange, setDayChange] = useState(0);
  const [options, setOptions] = useState(null);

  useEffect(() => {
    setDayChange(-2);
  }, [data]);

  useEffect(() => {
    const prices = data?.data?.quotes;
    if (!prices?.length) return;
    const percent = prices[23]?.quote?.USD.price / prices[0]?.quote?.USD.price;
    let dayChange = 0;
    if (percent >= 1.02) {
      dayChange = 1;
    } else if (percent <= 0.98) {
      dayChange = -1;
    }

    setSeries(
      prices?.map(
        (item) =>
          item?.quote?.USD.price,
      ),
    );
    let color = dayChange === 0 ? '#ECB533' : dayChange === 1 ? '#48BB78' : '#DE383D';
    let delta = ((prices[23]?.quote?.USD.price - prices[0]?.quote?.USD.price) * 100) / prices[0]?.quote?.USD.price;
    onDeltaChange(
      new Intl.NumberFormat('en-US', { signDisplay: 'exceptZero', style: 'unit', unit: 'percent' }).format(
        delta === undefined ? '...' : delta.toFixed(2),
      ),
      color,
    );
    const newOptions = { ...InitialOptions };
    newOptions.fill.gradient.colorStops = [
      {
        offset: 0,
        color: '#4B24DC',
        opacity: 0.1,
      },
      {
        offset: 100,
        color: color,
        opacity: 1,
      },
    ];
    newOptions.tooltip.y.formatter = (value) =>
      new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
    newOptions.annotations.points[0].y = prices[23]?.quote?.USD.price;
    setOptions(newOptions);
    setTimeout(() => setDayChange(dayChange), 300);
  }, [data, onDeltaChange]);

  if (data == null) return null;
  return series && dayChange >= -1 && options ? (
    <Chart options={options} series={[{ name: 'Price', data: series }]} height="100%" width="87%"/>
  ) : null;
};

export default ApexChart;
